import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 用于集团业务的跳转识别
    groupName: 'traffic'
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
